import itemService from '../../services/item-service';

const state = () => ({

    loading: false,
    items: [],
    error: null
})

const actions = {
    getAll({ commit }) {
        commit('Loading', true);

        itemService.getAll()
            .then(
                items => {
                    //console.log(items);
                    commit('Success', items.data);
                    commit('Failure', null)

                },
                error => commit('Failure', error)
            );
    },
    add({ commit, state }, data) {
        itemService.create(data)
            .then(
                response => {
                    if (response.status == 200) {
                        data.id = response.data.id;
                        commit('Add',data);
                        commit('Failure', null)
                    }
                },
                error => commit('Failure', error)
            )

    },
    delete({ commit, state }, data) {
        itemService.delete(data.item.id)
            .then(
                response => {
                    //state.items.splice(data.index, 1)
                    commit('Remove', data.index)
                    commit('Failure', null)
                },
                error => commit('Failure', error)
            )
    },
    update({ commit, state }, data) {

        itemService.update(data.item.id, data.item)
            .then(
                success => {
                    

                    commit('Update',data);
                    commit('Failure', null)
                },
                error => commit('Failure', error)
            )

    },
    readdSaleItemToStock({ commit }, data) { //incase sale item is removed from sale list this will readd it to the stock items
        commit('Readd', data)
    },
    removeSaleItemFromStock({ commit }, index) {
        commit('Remove', index)
    }
}


const mutations = {
    Loading(state, status) {
        state.loading = status;
    },
    Success(state, items) {
        state.items = items;
        state.loading = false;
    },
    Add(state,payload){
        state.items.unshift(payload);
    },
    Update(state,data){
        Object.assign(state.items[data.index], data.item);
    },
    Failure(state, error) {
        state.error = error;
    },
    Deleted_item(state, payload) {
        //to be implemented for undo feature later
    },
    Readd(state, data) { //reads stock item to stock incase it is deleted from sale items
        state.items.unshift(data);
    },
    Remove(state, index) {
        state.items.splice(index, 1)
    }

}

const getters = {
    ITEMS: state => {
        return state.items
    },

    ITEM_ERROR: state => {
        return state.error
    },
    ITEMS_LOADING: state => {
        return state.loading
    },


}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}